import React from "react";
import {GalleryItemData, ItemsActionResponse, ItemsDispatcher, ItemsGetFilesResponse} from "./ItemsProviderDomain";
import { ServicesUrl } from "../../Config/UrlRuotes";
import axios from "axios";

export async function getItems( token:string , dispatch:React.Dispatch<ItemsDispatcher>){
    const requestOptions = {
        method: 'GET',
        headers: { 'Authorization-Token':token },
    };

    try {
        dispatch({ type: 'REQUEST' });
        let response = await fetch(ServicesUrl.items, requestOptions);
        let data : ItemsActionResponse = await response.json();

        if( data.error["has-error"] &&  data.error.error !== undefined ){
            dispatch({ type: 'ERROR', error: data.error.error});
            return ;
        }

        //setTimeout( () => {
            const itemsClass = data.response.map( data => new GalleryItemData(data) )
            dispatch({ type: 'SUCCESS', payload: {items:itemsClass} });
        //}, 2500);

        return dispatch
    }catch (error) {
        let message = "Error al momento de realizar la petición"
        dispatch({ type: 'ERROR', error: message});

        return ;
    }
}

export async function getFiles( token:string, ids:string[], dispatch:React.Dispatch<ItemsDispatcher>){
    const requestOptions = {
        method: 'POST',
        headers: { 'Authorization-Token':token },
        body: JSON.stringify( {ids:ids} ),
    };

    try {
        dispatch({ type: 'REQUEST', payload:{
            items:[],
                itemsMessageVariant:"info",
                itemsMessage:"Preparando la descarga, Esta acción puede tardar unos minutos..."
        } });
        let response = await fetch(ServicesUrl.items, requestOptions);
        let data : ItemsGetFilesResponse = await response.json();

        dispatch({ type: 'SUCCESS' });

        if( data.error["has-error"] &&  data.error.error !== undefined ){
            dispatch({ type: 'ERROR', error: data.error.error});
            return ;
        }

        if( data.response !== "" ) {
            dispatch({ type: 'SUCCESS'});
            autofirmFile(token, data.response, dispatch)
        }else{
            const message = "Error al momento de realizar la petición"
            dispatch({ type: 'ERROR', error: message});
        }

        return dispatch
    }catch (error) {
        let message = "Error al momento de realizar la petición"
        dispatch({ type: 'ERROR', error: message});

        return ;
    }
}

export async function autofirmFile( token:string, url:string, dispatch:React.Dispatch<ItemsDispatcher>){
    const requestOptions = {
        method: 'POST',
        headers: { 'Authorization-Token':token },
        body: JSON.stringify( {url:url} ),
    };

    try {
        dispatch({ type: 'REQUEST', payload:{
                items:[],
                itemsMessageVariant:"info",
                itemsMessage:"Validando la descarga..."
            } });

        let response = await fetch(ServicesUrl.autoFirm, requestOptions);
        let data : ItemsGetFilesResponse = await response.json();

        if( data.error["has-error"] &&  data.error.error !== undefined ){
            dispatch({ type: 'ERROR', error: data.error.error});
            return ;
        }else{
            dispatch({ type: 'REQUEST', payload:{
                    items:[],
                    itemsMessageVariant:"info",
                    itemsMessage:"Descargando Archivos..."
                } });

            const fileNameElements = url.split('/')
            const fileName = fileNameElements[ fileNameElements.length - 1 ]
            
            const link = document.createElement('a');
            await axios({
                url: data.response,
                method: 'GET',
                headers: {
                    "Access-Control-Allow-Origin": "*"
                },
                responseType: 'blob',
            }).then((response) => {

                const urlBloB = window.URL.createObjectURL(new Blob([response.data]));
                link.href = urlBloB;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();

                dispatch({ type: 'REQUEST', payload:{
                        items:[],
                        itemsMessageVariant:"success",
                        itemsMessage:"Archivos Descargados con éxito"
                    } });

                setTimeout( ()=>{
                    finishDownload(token, url, dispatch)
                }, 300 )
            }).catch(  (error) => {
                dispatch({ type: 'ERROR', error: error.message});
            } ).finally( ()=>{
                link.remove()
            } )
            /*
            await downloadRequest.then((response) => {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
            })


                .then( _response => {
                    isOK = true
                } )

                .finally( ()=>{
                    link.remove()
                } )

            if( isOK ){

                finishDownload(token, dispatch)
            }
             */

            return dispatch
        }
    }catch (error) {
        let message = "Error al momento de realizar la petición"
        dispatch({ type: 'ERROR', error: message});

        return ;
    }
}

export async function finishDownload( token:string, url:string, dispatch:React.Dispatch<ItemsDispatcher>){
    const urlElements = url.replace( '//', '' ).split('/')
    const flag = ( urlElements[1] === 'files' && urlElements[2] === 'tmp' )

    if( flag ){
        const requestOptions = {
            method: 'POST',
            headers: { 'Authorization-Token':token },
            body: JSON.stringify( {url:url} ),
        };

        try {
            dispatch({ type: 'REQUEST', payload:{
                    items:[],
                    itemsMessageVariant:"info",
                    itemsMessage:"Finalizando Descarga..."
                } });
            let response = await fetch(ServicesUrl.finish, requestOptions);
            let data : ItemsGetFilesResponse = await response.json();

            if( data.error["has-error"] &&  data.error.error !== undefined ){
                dispatch({ type: 'ERROR', error: data.error.error});
                return ;
            }

            getItems(token, dispatch)
            return dispatch
        }catch (error) {
            let message = "Error al momento de realizar la petición"
            dispatch({ type: 'ERROR', error: message});

            return ;
        }
    }


    setTimeout( ()=>{
        getItems(token, dispatch)
    }, 300 )

    return dispatch
}